import(/* webpackMode: "eager" */ "/yd-test/app/global-error.tsx");
